$(document).ready(function() {
//fetch cart items
  function fetchCart(callback) {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => callback(cart))
      .catch((err) => console.error("Cart fetch error:", err));
  }

  $(document).on('click', '.multi-prod-cart-addon', function (e) {
    setTimeout(function() {
      console.log('Multi-product Add to Cart clicked');

      // Collect only active addon products
      const addons = [];

      $('.product-add-on-part.active, .product-add-on-part-wc.active-wc').each(function () {
        const id = $(this).find('h3').attr('data-id');
        if (id) {
          addons.push({ id: Number(id), quantity: 1 });
        }
      });

      if (addons.length === 0) {
        console.log('No active addon products selected.');
        return;
      }

      console.log('Adding active addons:', addons);

      // Send all selected addons to Shopify cart
      $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify(addons.length === 1 ? addons[0] : { items: addons }),
        success: function (response) {
          fetchCart((cartItem) => {
          let updatedQuantity = cartItem.item_count || 0;
          $(".cart-count-bubble span").text(updatedQuantity);

          if (updatedQuantity === 0) {
            $("#CartDrawer").addClass("is-empty").removeClass("active");
            $("cart-drawer").addClass("is-empty");
          } else {
            $("cart-drawer").load(
              window.location.href + " #CartDrawer",
              function () {
                $("#CartDrawer").removeClass("is-empty").addClass("active");
                $("cart-drawer").removeClass("is-empty");
              }
            );
          }
        });
        },
        error: function (xhr, status, error) {
          console.error('Error adding addons:', error);
        }
      });
    }, 3000)
  
});

  /*) Start 0 Add to cart  */

  const giftProductId = $('.atc_button').attr('product_id');  
  const giftVariantId = $('.atc_button').attr('product_variant_id');  
  
  updateGiftQuantity(1); 
  
  $('.atc_button').on('click', function() {
      checkGiftInCart();
  });
  function checkGiftInCart() {
      $.getJSON('/cart.js', function(cart) {
          let giftProductInCart = false;
          cart.items.forEach(function(item) {
              if (item.variant_id === parseInt(giftVariantId)) {  // Use variant_id
                  giftProductInCart = true;
                  updateGiftQuantity(1);
              }
          });
          if (!giftProductInCart) {
              addGiftToCart();
          }
      });
  }
  function addGiftToCart() {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: {
            quantity: 1,
            id: giftVariantId 
        },
        dataType: 'json',
        success: function(cart) {
          let updatedQuantity = cart.item_count || 0;
          $('.header__count-bubble span').text(updatedQuantity);
          $('cart-drawer').load(window.location.href + ' #CartDrawer');
          $('cart-drawer').removeClass('is-empty');
          $('cart-drawer').addClass('active');
        },
        error: function(error) {
            console.error('Error adding gift to cart:', error);
        }
    });
  }
  function updateGiftQuantity(quantity) {
    // Find the cart item by giftVariantId in the cart drawer
    var giftIndex = null;
    $('#CartDrawer .cart-items .cart-item').each(function() {
        if ($(this).data('id') == giftVariantId) {
            giftIndex = $(this).data('line');
        }
    });

    if (giftIndex !== null) {
        $.ajax({
            url: '/cart/change.js',
            type: "post", 
            dataType: 'json',
            data: { 
                "line": giftIndex,
                "quantity": quantity,
            },
            success: function(cart) {
                console.log('Cart updated successfully:', cart);
            },
            error: function(error) {
                console.error('Error updating cart quantity:', error);
            }
        });
    } else {
        console.error('Gift item not found in the cart.');
    }
  }
  /*) End 0 Add to cart  */
  
  function featureCollectionSlider() {
    $('.new-featured-collection-section .new-featured-collection-slider').slick({
      infinite: false,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 3,
      prevArrow: '<button class="slide-arrow prev-arrow vertical-text">Previous</button>',
      nextArrow: '<button class="slide-arrow next-arrow vertical-text">Next</button>',
      arrows: true,
      dots: false,
      responsive: [
      {
         breakpoint: 1200,
         settings: {
            slidesToShow: 3,
            slidesToScroll: 3
         }
      },
      {
         breakpoint: 768,
         settings: {
            slidesToShow: 1.7,
            arrows: false,
            dots: false,
            slidesToScroll: 2
         }
      }]
    });
  }
  function featureTabCollectionSlider() {
    $('.tab-featured-collection-section .new-featured-collection-slider').slick({
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      prevArrow: '<button class="slide-arrow prev-arrow vertical-text">Previous</button>',
      nextArrow: '<button class="slide-arrow next-arrow vertical-text">Next</button>',
      arrows: true,
      dots: true,
      responsive: [
      {
         breakpoint: 1200,
         settings: {
            slidesToShow: 3,
            slidesToScroll: 3
         }
      },
      {
         breakpoint: 768,
         settings: {
            slidesToShow: 2.5,
            arrows: false,
            dots: false,
            slidesToScroll: 2
         }
      }]
    });
  }

  /*) ENd 0 Add to cart  */
  

  function collectionSlider() {
    $('.wc-index .collection-slider .brands-list').slick({
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        prevArrow: '<button class="slide-arrow prev-arrow vertical-text">Previous</button>',
        nextArrow: '<button class="slide-arrow next-arrow vertical-text">Next</button>',
        arrows: true,
        dots: true,
        responsive: [
        {
           breakpoint: 767,
           settings: {
              slidesToShow: 1.5,
              arrows: false,
              dots: false,
              slidesToScroll: 1
           }
        }]
    });
  }

  function categorySlider() {
    $('.wc-index .category-slider .brands-list').slick({
        infinite: false,
        speed: 500,
        slidesToShow: 4.5,
        slidesToScroll: 4,
        arrows: false,
        dots: false
    });
  }

  function aboutSlider() {
    $('.about-us ul.multicolumn-list').slick({
      infinite: false,
      speed: 500,
      slidesToShow: 2.5,
      slidesToScroll: 2,
      arrows: false,
      dots: false
    });
  }

  function CompleteLookProductSlider() {
    $('.complete-look-coll-slider').slick({
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      prevArrow: '<button class="slide-arrow prev-arrow vertical-text">Previous</button>',
      nextArrow: '<button class="slide-arrow next-arrow vertical-text">Next</button>',
      arrows: true,
      dots: true,
      responsive: [
      {
         breakpoint: 1200,
         settings: {
            slidesToShow: 3,
            slidesToScroll: 3
         }
      },
      {
         breakpoint: 768,
         settings: {
            slidesToShow: 2.2,
            arrows: false,
            dots: false,
            slidesToScroll: 1
         }
      }
      ,
      {
         breakpoint: 575,
         settings: {
            slidesToShow: 1.8,
            arrows: false,
            dots: false,
            slidesToScroll: 1
         }
      }
    ],
    });
  }

   function MoreFromProductSlider() {
    $('.more-from-coll-slider').slick({
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      prevArrow: '<button class="slide-arrow prev-arrow vertical-text">Previous</button>',
      nextArrow: '<button class="slide-arrow next-arrow vertical-text">Next</button>',
      arrows: true,
      dots: true,
      responsive: [
      {
         breakpoint: 1200,
         settings: {
            slidesToShow: 3,
            slidesToScroll: 3
         }
      },
      {
         breakpoint: 768,
         settings: {
            slidesToShow: 2.2,
            arrows: false,
            dots: false,
            slidesToScroll: 2
         }
      }]
    });
  }

  featureCollectionSlider();
  featureTabCollectionSlider();
  collectionSlider();
  CompleteLookProductSlider()
  MoreFromProductSlider()

   function relatedProductSlider() {
    $('.related-products .new-featured-collection-slider').slick({
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      prevArrow: '<button class="slide-arrow prev-arrow vertical-text">Previous</button>',
      nextArrow: '<button class="slide-arrow next-arrow vertical-text">Next</button>',
      arrows: true,
      dots: true,
      responsive: [
      {
         breakpoint: 1200,
         settings: {
            slidesToShow: 3,
            slidesToScroll: 3
         }
      },
      {
         breakpoint: 768,
         settings: {
            slidesToShow: 2.2,
            arrows: false,
            dots: false,
            slidesToScroll: 2
         }
      }]
    });
  }
  relatedProductSlider();
    setTimeout(function(){
      if($('.new-featured-collection-slider').hasClass('slick-slider')){
        
      }else{
     relatedProductSlider();
      }
    }, 3000);

    setTimeout(function(){
      if($('.new-featured-collection-slider').hasClass('slick-slider')){
        
      }else{
     relatedProductSlider();
      }
  }, 6000)

    setTimeout(function(){
      if($('.new-featured-collection-slider').hasClass('slick-slider')){
        
      }else{
     relatedProductSlider();
      }
  }, 8000)
    setTimeout(function(){
      if($('.new-featured-collection-slider').hasClass('slick-slider')){
        
      }else{
     relatedProductSlider();
      }
  }, 12000)

  $(window).scroll(function(){
     function relatedProductSlider() {
    $('.related-products .new-featured-collection-slider').slick({
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      prevArrow: '<button class="slide-arrow prev-arrow vertical-text">Previous</button>',
      nextArrow: '<button class="slide-arrow next-arrow vertical-text">Next</button>',
      arrows: true,
      dots: true,
      responsive: [
      {
         breakpoint: 1200,
         settings: {
            slidesToShow: 3,
            slidesToScroll: 3
         }
      },
      {
         breakpoint: 768,
         settings: {
            slidesToShow: 2.2,
            arrows: false,
            dots: false,
            slidesToScroll: 2
         }
      }]
    });
  }
      if($('.new-featured-collection-slider').hasClass('slick-slider')){
        
      }else{
     relatedProductSlider();
      }

  });
  

  // Reinitialize Slick after window load
  $(window).on('load', function() {
    $('.wc-index .collection-slider .brands-list').slick('setPosition');
    $('.wc-index .category-slider .brands-list').slick('setPosition');
    
    setTimeout(function(){
      $('.about-us ul.multicolumn-list').slick('setPosition');
    }, 1000)
    
     // Trigger resize event to recalculate widths
    $(window).trigger('resize');

    function relatedProductSlider() {
    $('.related-products .new-featured-collection-slider').slick({
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      prevArrow: '<button class="slide-arrow prev-arrow vertical-text">Previous</button>',
      nextArrow: '<button class="slide-arrow next-arrow vertical-text">Next</button>',
      arrows: true,
      dots: true,
      responsive: [
      {
         breakpoint: 1200,
         settings: {
            slidesToShow: 3,
            slidesToScroll: 3
         }
      },
      {
         breakpoint: 768,
         settings: {
            slidesToShow: 2.2,
            arrows: false,
            dots: false,
            slidesToScroll: 2
         }
      }]
    });
  }
relatedProductSlider();
    setTimeout(function(){
      if($('.new-featured-collection-slider').hasClass('slick-slider')){
        
      }else{
     relatedProductSlider();
      }
    }, 3000);

    setTimeout(function(){
      if($('.new-featured-collection-slider').hasClass('slick-slider')){
        
      }else{
     relatedProductSlider();
      }
  }, 6000)

    setTimeout(function(){
      if($('.new-featured-collection-slider').hasClass('slick-slider')){
        
      }else{
     relatedProductSlider();
      }
  }, 8000)
    setTimeout(function(){
      if($('.new-featured-collection-slider').hasClass('slick-slider')){
        
      }else{
     relatedProductSlider();
      }
  }, 12000)
    setTimeout(function(){
    $('.wc-product .video-section__poster').trigger('click');
      
      }, 1000)
    $('.prod_desc_tab_open details summary').trigger('click');
  });

  // initialize Slick on mobile screen
  if(window.innerWidth < 768) { 
     categorySlider();
    // aboutSlider();
  }

  $('.know-more-less-a-btn').on('click', function(e){
    e.preventDefault();
    $('.prod-desc-accor-sec').toggleClass('active');
    if($('.prod-desc-accor-sec').hasClass('active')){
      $('.know-more-less-a-btn').text('Know less');
    }else{
      $('.know-more-less-a-btn').text('Know more')
    }
  })

  $('.i-button-container').click(function(){
    $('.i-button-container .i-hover-message').hide();
    $(this).children('.i-hover-message').show();
  })


})


//Sticky transparent header 
var header = $('.sticky_transparent_header');
var headerOffset = header.offset().top;
$(window).scroll(function() {
    if ($(window).scrollTop() > 50) {
      $('#shopify-section-sections--21993464135957__1734342782dd825697').addClass('announc-sticky');
        header.removeClass('transparent_header');
    } else {
        header.addClass('transparent_header');
    }
});

// Tab feature collection section
'use strict';
function Tabs() {
  var bindAll = function() {
    var menuElements = document.querySelectorAll('[data-tab]');
    for(var i = 0; i < menuElements.length ; i++) {
      menuElements[i].addEventListener('click', change, false);
    }
  }
  var clear = function() {
    var menuElements = document.querySelectorAll('[data-tab]');
    for(var i = 0; i < menuElements.length ; i++) {
      menuElements[i].classList.remove('active');
      var id = menuElements[i].getAttribute('data-tab');
      document.getElementById(id).classList.remove('active');
    }
  }
  var change = function(e) {
    clear();
    e.target.classList.add('active');
    var id = e.currentTarget.getAttribute('data-tab');
    document.getElementById(id).classList.add('active');
  }
  bindAll();
}
var connectTabs = new Tabs();

//advance slideshow
$(document).ready(function() {
  const $asCarousel = $("#asCarousel");
  const $nextBtn = $("#asCarousel-next");
  const $prevBtn = $("#asCarousel-prev");
  
  $nextBtn.on("click", function() {
    const $firstChild = $asCarousel.children().first();
    const $clone = $firstChild.clone(true);
    $firstChild.remove();
    $asCarousel.append($clone);
  });
  
  $prevBtn.on("click", function() {
    const $lastChild = $asCarousel.children().last();
    const $clone = $lastChild.clone(true);
    $lastChild.remove();
    $asCarousel.prepend($clone);
  });
});

//stack media
$(document).ready(function() {
  const $asCarousel = $("#stackCarousel");
  const $nextBtn = $("#stackCarousel-next");
  const $prevBtn = $("#stackCarousel-prev");
  const $prevBtnVideo = $("#stackCarousel-prev");
  const $paginationDots = $("#paginationDots");
  const $carouselItems = $asCarousel.find('.stackCarousel__item');
  const totalItems = $carouselItems.length;
  let activeIndex = 0;

  function createPaginationDots() {
    for (let i = 0; i < totalItems; i++) {
      $paginationDots.append(`<span class="dot" data-index="${i}"></span>`);
    }
    $paginationDots.children().first().addClass('active');
  }

  function updatePaginationDots() {
    $paginationDots.children().removeClass('active');
    $paginationDots.children().eq(activeIndex).addClass('active');
  }

  function playActiveVideo() {
    $asCarousel.find('.stackCarousel__item video').each(function() {
      this.pause();
      this.currentTime = 0;
    });
    $asCarousel.find('.stackCarousel__item').eq(activeIndex).find('video')[0].play();
    updatePaginationDots();
  }

  $nextBtn.on("click", function() {
    activeIndex = (activeIndex + 1) % totalItems;
    const $firstChild = $asCarousel.children().first();
    const $clone = $firstChild.clone(true);
    $firstChild.remove();
    $asCarousel.append($clone);
    $(this).parents('.stack-media--section').removeClass('active');
    $('.stackCarousel__item').removeClass('active');
    playActiveVideo();
  });

  $prevBtn.on("click", function() {
    activeIndex = (activeIndex - 1 + totalItems) % totalItems;
    const $lastChild = $asCarousel.children().last();
    const $clone = $lastChild.clone(true);
    $lastChild.remove();
    $asCarousel.prepend($clone);
   // playActiveVideo();
    console.log('ifff');
    $(this).parents('.stack-media--section').addClass('active');
    $('.stackCarousel__item').removeClass('active');
    setTimeout(function(){
    $('.stackCarousel__item:first-child').addClass('active');
      }, 1)
  });

  $prevBtnVideo.on("click", function() {
    activeIndex = (activeIndex - 1 + totalItems) % totalItems;
    const $lastChild = $asCarousel.children().last();
    const $clone = $lastChild.clone(true);
    $lastChild.remove();
    $asCarousel.prepend($clone);
    playActiveVideo();
  });

  

  
  $paginationDots.on("click", ".dot", function() {
    const index = $(this).data("index");
    moveToIndex(index);
  });

  function moveToIndex(index) {
    activeIndex = index;
    const $activeItem = $asCarousel.find('.stackCarousel__item').eq(activeIndex);
    const $clonedItems = $asCarousel.find('.stackCarousel__item').slice(0, index).clone(true);

    $asCarousel.find('.stackCarousel__item').slice(0, index).remove();
    $asCarousel.append($clonedItems);

    playActiveVideo();
  }

  createPaginationDots();
  playActiveVideo();
});

//Mobile Responsive JS
$(document).ready(function() {
  if(window.innerWidth < 768) { 
     multiColumnReadMore();
     richTextReadMore();
     // productTitleLess();
  }
function multiColumnReadMore() {
      //This limit you can set after how much characters you want to show Read More.
      var carLmt = 25;
      // Text to show when text is collapsed
      var readMoreTxt = " ...read more";
      // Text to show when text is expanded
      var readLessTxt = " read less";


      //Traverse all selectors with this class and manupulate HTML part to show Read More
      $(".multicolumn.about-us .add-read-more").each(function () {
         if ($(this).find(".first-section").length)
            return;

         var allstr = $(this).text();
         if (allstr.length > carLmt) {
            var firstSet = allstr.substring(0, carLmt);
            var secdHalf = allstr.substring(carLmt, allstr.length);
            var strtoadd = firstSet + "<span class='second-section'>" + secdHalf + "</span><span class='read-more'  title='Click to Show More'>" + readMoreTxt + "</span><span class='read-less' title='Click to Show Less'>" + readLessTxt + "</span>";
            $(this).html(strtoadd);
         }
      });

      //Read More and Read Less Click Event binding
      $(document).on("click", ".read-more,.read-less", function () {
         $(this).closest(".add-read-more").toggleClass("show-less-content show-more-content");
      });
   }
  
function richTextReadMore() {
      //This limit you can set after how much characters you want to show Read More.
      var carLmt = 100;
      // Text to show when text is collapsed
      var readMoreTxt = " ...read more";
      // Text to show when text is expanded
      var readLessTxt = " read less";


      //Traverse all selectors with this class and manupulate HTML part to show Read More
      $(".home-rich-text .rich-read-more").each(function () {
         if ($(this).find(".home-rich-text .first-section").length)
            return;

         var allstr = $(this).text();
         if (allstr.length > carLmt) {
            var firstSet = allstr.substring(0, carLmt);
            var secdHalf = allstr.substring(carLmt, allstr.length);
            var strtoadd = firstSet + "<span class='second-section'>" + secdHalf + "</span><span class='read-more'  title='Click to Show More'>" + readMoreTxt + "</span><span class='read-less' title='Click to Show Less'>" + readLessTxt + "</span>";
            $(this).html(strtoadd);
         }
      });

      //Read More and Read Less Click Event binding
      $(document).on("click", ".read-more,.read-less", function () {
         $(this).closest(".rich-read-more").toggleClass("rich-show-less rich-show-more");
      });
   }

// function productTitleLess() {
//      let titleElement = $(".new-featured-collection-wrap h4 a");
//             let fullText = titleElement.text();
//             let words = fullText.split(" ");

//             if(words.length > 5) {
//                 let shortenedText = words.slice(0, 3).join(" ") + "...";
//                 titleElement.text(shortenedText).addClass("shortened-title").attr("title", fullText);
//             }
// }

  $('.slider-mobile-gutter .slider-counter__link').on('click', function(e){
    e.preventDefault();
    $('.slider-mobile-gutter .slider-counter__link').removeClass('active');
    $(this).addClass('active');
    var link_qty = $(this).attr('data-id')
    $('.thumbnail-slider ul li[data-slick-index="'+link_qty+'"] button').trigger('click');
  })

  $(document).on("click", ".read-more", function (e) {
    e.preventDefault();
         $(this).parents(".card_desc").toggleClass("show-less-content");
    $(this).parents(".card_desc").find('.read-less').show();
    $(this).parents(".card_desc").find('.read-more').hide();
      });
  $(document).on("click", ".read-less", function (e) {
    e.preventDefault();
         $(this).parents(".card_desc").toggleClass("show-less-content");
    $(this).parents(".card_desc").find('.read-more').show();
    $(this).parents(".card_desc").find('.read-less').hide();
      });

   $(document).on("click", ".read-more", function (e) {
    e.preventDefault();
         $(this).parents(".rich-read-more").toggleClass("show-less-content");
    $(this).parents(".rich-read-more").find('.read-less').show();
    $(this).parents(".rich-read-more").find('.read-more').hide();
      });
  $(document).on("click", ".read-less", function (e) {
    e.preventDefault();
         $(this).parents(".rich-read-more").toggleClass("show-less-content");
    $(this).parents(".rich-read-more").find('.read-more').show();
    $(this).parents(".rich-read-more").find('.read-less').hide();
      });

  $('#paginationDots .dot').on('click', function(){
    $(this).parents('#paginationDots').find('.dot').removeClass('active');
    $(this).addClass('active');
  })

  $('.slick-dots').each(function(){
    var size_count = $(this).find('li').length;
    console.log('size_count',size_count)
    if(size_count == 1){
      $(this).hide()
    }
  })
  
});

